//@ts-ignore
import NumericInput from './numericInput.tsx';

export default NumericInput;
